import { useMemo } from 'react';
import { useTranslations } from '@lang';

export const useExtrasLabels = () => {
  const { t } = useTranslations();

  return useMemo(
    () => ({
      subtitle: t('spa.extras.subtitle'),
      backAriaLabel: t('spa.booking.goBack'),
      footerTotal: t('basket.total'),
      add: t('spa.extrasSelectCTA'),
      remove: t('spa.extrasSelectedCTA'),
      quantity: t('spa.extras.quantity'),
      editSelections: t('spa.extras.editSelections'),
      noImage: t('spa.noImage'),
      modalTitle: t('treatment.selectGuestsCTA'),
      modalConfirm: t('modalError.confirm'),
      modalClose: t('journeypicker.close'),
      modalTotal: t('basket.total'),
    }),
    [t]
  );
};
